import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type CreatePartnerMediaFileRequest,
  postPartnersMediaFiles,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { MEDIA_FILES_QUERY_KEYS } from "MusicAudio/Api/Queries/queryKeys";

export function useUploadMediaFileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (request: CreatePartnerMediaFileRequest) =>
        postPartnersMediaFiles(request),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.CreatePartnerMediaFile,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: MEDIA_FILES_QUERY_KEYS.all,
      });
    },
  });
}
